import { render, staticRenderFns } from "./AccountWatchlist.vue?vue&type=template&id=07d1ea6e&scoped=true&"
import script from "./AccountWatchlist.vue?vue&type=script&lang=js&"
export * from "./AccountWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./AccountWatchlist.vue?vue&type=style&index=0&id=07d1ea6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1ea6e",
  null
  
)

export default component.exports